import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,
    StyledModalHeader,
    StyledModalOverlay,
    StyledModalParagraph,
    StyledModalTitle
} from '@components/ui/modal-atoms/style.ts'
import {ButtonHTMLAttributes, forwardRef, HTMLAttributes} from 'react'
import {Button} from '@components/ui/button/Button.tsx'
import {XCloseIcon} from '@components/ui/icon/Icon.tsx'
import {Portal} from '@ariakit/react'
import {CSSProperties} from 'styled-components'

export const ModalOverlay = (props: HTMLAttributes<HTMLDivElement>) => (
    <Portal>
        <StyledModalOverlay {...props} />
    </Portal>
)
export const Modal = ({
    width,
    overflowY,
    ...props
}: HTMLAttributes<HTMLDivElement> & {width: string; overflowY?: CSSProperties['overflowY']}) => (
    <Portal>
        <StyledModal $width={width} $overflowY={overflowY} {...props} />
    </Portal>
)
export const ModalHeader = (props: HTMLAttributes<HTMLDivElement>) => <StyledModalHeader {...props} />
export const ModalBody = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>((props, ref) => (
    <StyledModalBody ref={ref} {...props} />
))
export const ModalFooter = (props: HTMLAttributes<HTMLDivElement>) => <StyledModalFooter {...props} />
export const ModalTitle = (props: HTMLAttributes<HTMLHeadingElement>) => <StyledModalTitle {...props} />
export const ModalParagraph = (props: HTMLAttributes<HTMLParagraphElement>) => <StyledModalParagraph {...props} />
export const ModalXCloseButton = ({
    btnSize = 'sm',
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {btnSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'}) => (
    <Button variant="ghost" size={btnSize} shape="square" {...props}>
        <XCloseIcon />
    </Button>
)
